'use strict';
const PROVIDER_NAME = 'microsoft',
	mindmupProfile = require('./mindmup-profile');
module.exports = function MicrosoftAuthenticator({microsoftOAuthApi, authenticationModel, goldApi, tokenParser} = {}, optional) {
	if (!microsoftOAuthApi || !authenticationModel || !goldApi || !tokenParser) {
		throw new Error('invalid-args');
	}
	let currentMMProfile;
	const notifyStart = function () {
			authenticationModel.authenticationStarted();
		},
		notifyFailure = function (reason) {
			const knownBlockReasons = ['blocked', 'networkError'],
				authFailureName = knownBlockReasons.includes(reason) ? 'microsoft-blocked' : false;
			authenticationModel.authenticationFailed(authFailureName);
			throw reason;
		},
		notifySuccess = function (mmProfile) {
			if (mmProfile) {
				authenticationModel.authenticatedProfile(() => mmProfile);
			}
			return mmProfile;
		},
		requestLicenseUsingMicrosoft = (token, allowUnlicensed, remainingRetries) => {
			const parsed = tokenParser.parseJWT(token),
				tenant = parsed?.tid;
			return goldApi.exec('license/request_license_using_microsoft', {token, personal: !tenant})
			.catch((reason) => {
				if (allowUnlicensed && ['not-registered', 'domain-expired', 'domain-not-purchased'].includes(reason)) {
					return false;
				}
				if (reason === 'server-error' && remainingRetries) {
					const decremented = remainingRetries - 1;
					return requestLicenseUsingMicrosoft(token, allowUnlicensed, decremented);
				}
				throw reason;
			});

		},
		toMindmupProfile = function (microsoftProfile) {
			const allowUnlicensed = optional && optional.allowUnlicensed;
			return requestLicenseUsingMicrosoft(microsoftProfile.token, allowUnlicensed, 3)
			.then((license) => mindmupProfile(PROVIDER_NAME, microsoftProfile.email, license, microsoftProfile, {domain: microsoftProfile.domain}));
		},
		notifySuggestedEmail = (microsoftProfile) => {
			authenticationModel.setSuggestedEmail(microsoftProfile.email);
			return microsoftProfile;
		},
		authenticate = function (authMethod, options, skipConfirmation) {
			notifyStart();
			return microsoftOAuthApi[authMethod](options)
			.then(notifySuggestedEmail)
			.then((microsoftProfile) => toMindmupProfile(microsoftProfile))
			.then((mmProfile) => {
				currentMMProfile = mmProfile;
				if (!skipConfirmation) {
					return mmProfile;
				}
				return notifySuccess(mmProfile);
			})
			.catch(notifyFailure);
		},
		providerName = function () {
			return PROVIDER_NAME;
		},
		confirmImpl = () => notifySuccess(currentMMProfile),
		authResponseToProfile = (authResponse) => {
			return microsoftOAuthApi.authResponseToProviderProfile(authResponse)
			.then((microsoftProfile) => toMindmupProfile(microsoftProfile))
			.then((mmProfile) => notifySuccess(mmProfile))
			.catch(notifyFailure);
		},
		backgroundAuthenticate = function (requestedUserId, additionalScopes) {
			const callOptions = {
				login_hint: requestedUserId
			};
			if (additionalScopes) {
				callOptions.additionalScopes = additionalScopes;
			}
			return authenticate('headlessAuth', callOptions, true);
		},
		modalAuthenticate = function (requestedUserId) {
			const skipConfirmation = optional && optional.skipConfirmation;
			return authenticate('dialogAuth', {login_hint: requestedUserId}, skipConfirmation);
		},
		changeAccount = function () {
			const skipConfirmation = optional && optional.skipConfirmation;
			return authenticate('dialogAuth', {prompt: 'select_account'}, skipConfirmation);

		};
	Object.freeze(Object.assign(this, {providerName, confirm: confirmImpl, authResponseToProfile, backgroundAuthenticate, modalAuthenticate, changeAccount}));
};

